import TemplateView from '../../../../TemplateView'
import TableControlsContainer from './TableControlsContainer'
import messageResource from '../../../../messageResource'
import {userNameCapitalized, userNameCapitalizedPlural} from '../../../../util/pluralizeUtils'

export default class TableHead extends TemplateView {
    constructor({
        workAssignmentsFilter = null,
        viewerManagementCountersComponent = null,
    }) {
        super(null)

        this.workAssignmentsFilter = workAssignmentsFilter
        this.viewerManagementCountersComponent = viewerManagementCountersComponent

        this.state = {
            assignedUserIds: null
        }

        this.onStateChanged(() => {
            const allAssigned = this.state.assignedUserIds === null

            let val = allAssigned ? messageResource.getMessage('common.all') : this.state.assignedUserIds.length
            let text = allAssigned ? userNameCapitalizedPlural() : userNameCapitalized(this.state.assignedUserIds.length)
            this.$teamDetails.text(`(${val} ${text})`)
        })
    }

    templateHtml() {
        return '<thead class="tableHead">' +
               '  <tr class="userListHead firstHeader">' +
               '    <th class="userName firstLayer">' +
               '     <div class="cellName"><%=myTeam%></div>' +
               '     <span class="details teamDetails"></span>' +
               '    </th>' +
               '    <th class="spacer firstLayer"></th>' +
               '    <th class="workAssignmentsHeader firstLayer">' +
               '       <%=myScope%><span class="details">(<%=myScopeDetails%>)</span>' +
               '       <div class="workAssignmentsFilter"></div>' +
               '    </th>' +
               '    </tr>' +
               '    <tr class="userListHead secondHeader">' +
               '      <th class="controlsPlaceholder userName secondLayer"></th>' +
               '      <th class="spacer secondLayer"></th>' +
               '      <th class="workAssignmentsHeader secondLayer"></th>' +
               '    </tr>' +
               '</thead>'
    }


    messageKeys() {
        return {
            myScope: 'userlist.work_assignments.table.my_scope',
            myScopeDetails: 'userlist.work_assignments.table.i_can_assign',
            myTeam: 'userlist.work_assignments.table.my_team'
        }
    }

    afterRender() {
        this.$teamDetails = this.find('.details.teamDetails')
        new TableControlsContainer().init(this.find('.controlsPlaceholder'))
        this.workAssignmentsFilter.init(this.find('.workAssignmentsFilter'))
        this.viewerManagementCountersComponent.init(this.find('.workAssignmentsHeader.secondLayer'))

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/components/TableHead.js